// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif !important;
  box-sizing: border-box;
}

/* Темная тема (по умолчанию) */
body.dh-theme-dark .teacher-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

/* Светлая тема */
body.dh-theme-light .teacher-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: relative;
}

/* Светлая тема - заголовки страниц для преподавателя */
body.dh-theme-light .content-title {
  color: #002FA7; /* Синий цвет для заголовка в светлой теме */
}

body.dh-theme-light .content-subtitle {
  color: #002FA7; /* Синий цвет для подзаголовка в светлой теме */
  font-weight: 500; 
}

/* Для темной темы сохраняем белый цвет */
body.dh-theme-dark .content-title {
  color: white;
}

body.dh-theme-dark .content-subtitle {
  color: white;
}


body.dh-theme-light .th-dropdown-user-info .th-user-gradient-bg {
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  opacity: 1;
  z-index: 1;
}

body.dh-theme-light .th-dropdown-fullname{
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0d2e82;
  margin-bottom: 4px;
}

body.dh-theme-light .th-dropdown-department{
  display: block;
  font-size: 13px;
  color: #002FA7;
  font-weight: 400;
}

.teacher-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

.teacher-content {
  position: relative;
  z-index: 1;
  padding: 20px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Основной контент */
.teacher-main {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  width: 100%;
  margin-top: 20px;
  transition: grid-template-columns 0.3s ease;
}

.teacher-main.sidebar-collapsed {
  grid-template-columns: 80px 1fr;
}

/* Боковая панель */
.t-sidebar {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 580px;
  position: relative;
  transition: all 0.3s ease;
  z-index: 1;
}

.t-sidebar.collapsed {
  width: 80px;
  padding: 24px 16px;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  height: 560px;
}

.t-sidebar.collapsed .sidebar-header,
.t-sidebar.collapsed .nav-text,
.t-sidebar.collapsed .sidebar-footer,
.t-sidebar.collapsed .nav-indicator {
  display: none;
}

.t-sidebar.collapsed .sidebar-nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 100%;
  margin-top: 0;
  z-index: 1;
}

.t-sidebar.collapsed .nav-item {
  width: 52px;
  height: 52px;
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  display: flex;
  position: relative;
  margin: 0;
  z-index: 1;
}

.t-sidebar.collapsed .nav-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.t-sidebar.collapsed .nav-svg-icon {
  width: 34px;
  height: 34px;
}


.t-sidebar.collapsed .nav-item:hover::after {
  opacity: 1;
}

/* Кнопка сворачивания */
.sidebar-toggle {
  position: absolute;
  top: 16px;
  right: -12px;
  width: 24px;
  height: 24px;
  border: 2px solid;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 2;
}

.sidebar-toggle:hover {

  transform: scale(1.1);
  background-color: white;  
}

.t-sidebar.collapsed .sidebar-toggle {
  transform: rotate(180deg);
}

/* Контент боковой панели */
.sidebar-header {
  text-align: center;
  margin-bottom: 16px;
}

.user-fullname-small {
  color: #002fa7;
  font-size: 20px;
  font-weight: 600;
  margin: 20 0 12px 0;
  line-height: 1.3;
  margin-bottom: 20px;
}

.user-info .user-name {
  color: #002fa7;
  font-size: 12px;
  font-weight: 500;
  margin: 4px 100px;
}

.user-patronymic {
  color: #002fa7;
  font-size: 10px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.user-info .user-role {
  color: #002fa7;
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0 10 0 ;
}

.user-department {
  color: #002fa7;
  font-size: 12px;
  font-weight: 300;
  margin: 4px 0;
  margin-bottom: 20px;
}

/* Навигация */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.nav-item:hover {
  background: rgba(45, 74, 204, 0.1);
}

.nav-item.active {
  background: rgba(102, 126, 234, 0.15);
  font-weight: 600;
}

.nav-text {
  font-size: 14px;
  color: #002fa7;
}

.nav-indicator {
  width: 3px;
  height: 24px;
  background: #002fa7;
  border-radius: 2px;
  position: absolute;
  right: -24px;
}

/* Иконки */
.nav-svg-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}

.nav-svg-white-icon {
  width: 36px;
  height: 36px;
  margin: 6px 6px 0 4px;
}

.nav-toggle-icon {
  width: 28px;
  height:28px;
  z-index: 1;
}
  

/* Основная область контента */
.content-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  z-index: 3;
  position: relative;
}

.content-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  flex-wrap: nowrap;
  min-width: 0;
}

.content-title {
  color: white;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 0;
}

.content-subtitle {
  color: white;
  font-weight: 200;
  font-size: 14px;
  margin-top: 24px;
  margin-left: 20px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content-card {
  background: white;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  min-height: 550px;
  width: 100%;
  z-index: 1;
  position: relative;
}

/* Анимированный фон */
.background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.shape {
  position: absolute;
  opacity: 0.1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: float 20s infinite linear;
}

.shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }
.shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }
.shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }

.no-next-class {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  text-align: center;
  padding: 8px 0;
}

.next-class-room {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 2px;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(90deg); }
  50% { transform: translateY(0) rotate(180deg); }
  75% { transform: translateY(20px) rotate(270deg); }
}

/* Адаптивность */
@media (max-width: 1200px) {
  .teacher-content {
    max-width: 95vw;
    padding: 16px;
  }
}

@media (max-width: 1024px) {
  .teacher-main {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .teacher-main.sidebar-collapsed {
    grid-template-columns: 1fr;
  }
  
  .t-sidebar {
    order: 2;
    min-height: auto;
  }
  
  .t-sidebar.collapsed {
    width: 100%;
    padding: 20px;
    flex-direction: row;
  }
  
  .t-sidebar.collapsed .sidebar-nav {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
  }
  
  .t-sidebar.collapsed .nav-item {
    width: 60px;
    height: 60px;
  }
  
  .content-area {
    order: 1;
  }
  
  .nav-indicator,
  .sidebar-toggle {
    display: none;
  }
}

@media (max-width: 768px) {
  .teacher-content {
    padding: 12px;
  }
  
  .content-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    flex-wrap: wrap;
  }
  
  .content-title {
    font-size: 22px;
    white-space: normal;
  }
  
  .content-subtitle {
    margin-left: 0;
    font-size: 13px;
    white-space: normal;
  }
  
  .content-card {
    padding: 16px;
    min-height: 500px;
  }
  
  .quick-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .t-sidebar.collapsed {
    padding: 16px;
  }
  
  .t-sidebar.collapsed .nav-item {
    width: 50px;
    height: 50px;
  }
  
  .nav-svg-icon {
    width: 22px;
    height: 22px;
  }
  
  .nav-svg-white-icon {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 480px) {
  .teacher-content {
    padding: 8px;
  }
  
  .teacher-main {
    gap: 16px;
    margin-top: 16px;
  }
  
  .t-sidebar {
    padding: 16px;
    border-radius: 16px;
  }
  
  .content-card {
    padding: 12px;
    border-radius: 16px;
    min-height: 450px;
  }
  
  .user-info .user-name,
  .user-patronymic {
    font-size: 16px;
  }
  
  .content-title {
    font-size: 20px;
    gap: 8px;
  }
  
  .t-sidebar.collapsed .nav-item {
    width: 44px;
    height: 44px;
  }
  
  .nav-svg-icon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 360px) {
  .t-sidebar.collapsed .nav-item {
    width: 40px;
    height: 40px;
  }
  
  .nav-svg-icon {
    width: 18px;
    height: 18px;
  }
  
  .content-title {
    font-size: 18px;
  }
  
  .content-subtitle {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TeacherStyle.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,cAAc,EAAE,+CAA+C;EAC/D,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;;AAGA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,WAAW,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE;AAC7D,WAAW,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,UAAU,EAAE,oBAAoB,EAAE;AACpF,WAAW,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAEvF;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,0CAA0C,EAAE;EAClD,MAAM,uCAAuC,EAAE;EAC/C,MAAM,0CAA0C,EAAE;AACpD;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n  box-sizing: border-box;\n}\n\n/* Темная тема (по умолчанию) */\nbody.dh-theme-dark .teacher-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n/* Светлая тема */\nbody.dh-theme-light .teacher-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: relative;\n}\n\n/* Светлая тема - заголовки страниц для преподавателя */\nbody.dh-theme-light .content-title {\n  color: #002FA7; /* Синий цвет для заголовка в светлой теме */\n}\n\nbody.dh-theme-light .content-subtitle {\n  color: #002FA7; /* Синий цвет для подзаголовка в светлой теме */\n  font-weight: 500; \n}\n\n/* Для темной темы сохраняем белый цвет */\nbody.dh-theme-dark .content-title {\n  color: white;\n}\n\nbody.dh-theme-dark .content-subtitle {\n  color: white;\n}\n\n\nbody.dh-theme-light .th-dropdown-user-info .th-user-gradient-bg {\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  opacity: 1;\n  z-index: 1;\n}\n\nbody.dh-theme-light .th-dropdown-fullname{\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0d2e82;\n  margin-bottom: 4px;\n}\n\nbody.dh-theme-light .th-dropdown-department{\n  display: block;\n  font-size: 13px;\n  color: #002FA7;\n  font-weight: 400;\n}\n\n.teacher-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n.teacher-content {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Основной контент */\n.teacher-main {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  width: 100%;\n  margin-top: 20px;\n  transition: grid-template-columns 0.3s ease;\n}\n\n.teacher-main.sidebar-collapsed {\n  grid-template-columns: 80px 1fr;\n}\n\n/* Боковая панель */\n.t-sidebar {\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: 580px;\n  position: relative;\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n\n.t-sidebar.collapsed {\n  width: 80px;\n  padding: 24px 16px;\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n  height: 560px;\n}\n\n.t-sidebar.collapsed .sidebar-header,\n.t-sidebar.collapsed .nav-text,\n.t-sidebar.collapsed .sidebar-footer,\n.t-sidebar.collapsed .nav-indicator {\n  display: none;\n}\n\n.t-sidebar.collapsed .sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  height: 100%;\n  margin-top: 0;\n  z-index: 1;\n}\n\n.t-sidebar.collapsed .nav-item {\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n  display: flex;\n  position: relative;\n  margin: 0;\n  z-index: 1;\n}\n\n.t-sidebar.collapsed .nav-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.t-sidebar.collapsed .nav-svg-icon {\n  width: 34px;\n  height: 34px;\n}\n\n\n.t-sidebar.collapsed .nav-item:hover::after {\n  opacity: 1;\n}\n\n/* Кнопка сворачивания */\n.sidebar-toggle {\n  position: absolute;\n  top: 16px;\n  right: -12px;\n  width: 24px;\n  height: 24px;\n  border: 2px solid;\n  border-radius: 50%;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.sidebar-toggle:hover {\n\n  transform: scale(1.1);\n  background-color: white;  \n}\n\n.t-sidebar.collapsed .sidebar-toggle {\n  transform: rotate(180deg);\n}\n\n/* Контент боковой панели */\n.sidebar-header {\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.user-fullname-small {\n  color: #002fa7;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 20 0 12px 0;\n  line-height: 1.3;\n  margin-bottom: 20px;\n}\n\n.user-info .user-name {\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 4px 100px;\n}\n\n.user-patronymic {\n  color: #002fa7;\n  font-size: 10px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n}\n\n.user-info .user-role {\n  color: #002fa7;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 10px 0 10 0 ;\n}\n\n.user-department {\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 300;\n  margin: 4px 0;\n  margin-bottom: 20px;\n}\n\n/* Навигация */\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border: none;\n  background: transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.nav-item:hover {\n  background: rgba(45, 74, 204, 0.1);\n}\n\n.nav-item.active {\n  background: rgba(102, 126, 234, 0.15);\n  font-weight: 600;\n}\n\n.nav-text {\n  font-size: 14px;\n  color: #002fa7;\n}\n\n.nav-indicator {\n  width: 3px;\n  height: 24px;\n  background: #002fa7;\n  border-radius: 2px;\n  position: absolute;\n  right: -24px;\n}\n\n/* Иконки */\n.nav-svg-icon {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n}\n\n.nav-svg-white-icon {\n  width: 36px;\n  height: 36px;\n  margin: 6px 6px 0 4px;\n}\n\n.nav-toggle-icon {\n  width: 28px;\n  height:28px;\n  z-index: 1;\n}\n  \n\n/* Основная область контента */\n.content-area {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  z-index: 3;\n  position: relative;\n}\n\n.content-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.content-title {\n  color: white;\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  margin-left: 4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.content-subtitle {\n  color: white;\n  font-weight: 200;\n  font-size: 14px;\n  margin-top: 24px;\n  margin-left: 20px;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.content-card {\n  background: white;\n  border-radius: 20px;\n  padding: 28px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  min-height: 550px;\n  width: 100%;\n  z-index: 1;\n  position: relative;\n}\n\n/* Анимированный фон */\n.background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.shape {\n  position: absolute;\n  opacity: 0.1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: float 20s infinite linear;\n}\n\n.shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }\n.shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }\n.shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }\n\n.no-next-class {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 13px;\n  text-align: center;\n  padding: 8px 0;\n}\n\n.next-class-room {\n  font-size: 12px;\n  opacity: 0.9;\n  margin-top: 2px;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-20px) rotate(90deg); }\n  50% { transform: translateY(0) rotate(180deg); }\n  75% { transform: translateY(20px) rotate(270deg); }\n}\n\n/* Адаптивность */\n@media (max-width: 1200px) {\n  .teacher-content {\n    max-width: 95vw;\n    padding: 16px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .teacher-main {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .teacher-main.sidebar-collapsed {\n    grid-template-columns: 1fr;\n  }\n  \n  .t-sidebar {\n    order: 2;\n    min-height: auto;\n  }\n  \n  .t-sidebar.collapsed {\n    width: 100%;\n    padding: 20px;\n    flex-direction: row;\n  }\n  \n  .t-sidebar.collapsed .sidebar-nav {\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n  }\n  \n  .t-sidebar.collapsed .nav-item {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .content-area {\n    order: 1;\n  }\n  \n  .nav-indicator,\n  .sidebar-toggle {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .teacher-content {\n    padding: 12px;\n  }\n  \n  .content-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n  \n  .content-title {\n    font-size: 22px;\n    white-space: normal;\n  }\n  \n  .content-subtitle {\n    margin-left: 0;\n    font-size: 13px;\n    white-space: normal;\n  }\n  \n  .content-card {\n    padding: 16px;\n    min-height: 500px;\n  }\n  \n  .quick-stats {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .t-sidebar.collapsed {\n    padding: 16px;\n  }\n  \n  .t-sidebar.collapsed .nav-item {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .nav-svg-icon {\n    width: 22px;\n    height: 22px;\n  }\n  \n  .nav-svg-white-icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n@media (max-width: 480px) {\n  .teacher-content {\n    padding: 8px;\n  }\n  \n  .teacher-main {\n    gap: 16px;\n    margin-top: 16px;\n  }\n  \n  .t-sidebar {\n    padding: 16px;\n    border-radius: 16px;\n  }\n  \n  .content-card {\n    padding: 12px;\n    border-radius: 16px;\n    min-height: 450px;\n  }\n  \n  .user-info .user-name,\n  .user-patronymic {\n    font-size: 16px;\n  }\n  \n  .content-title {\n    font-size: 20px;\n    gap: 8px;\n  }\n  \n  .t-sidebar.collapsed .nav-item {\n    width: 44px;\n    height: 44px;\n  }\n  \n  .nav-svg-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 360px) {\n  .t-sidebar.collapsed .nav-item {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .nav-svg-icon {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .content-title {\n    font-size: 18px;\n  }\n  \n  .content-subtitle {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
